import script from "./OrdersFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersFrame.vue?vue&type=script&setup=true&lang=js"

import "./OrdersFrame.vue?vue&type=style&index=0&id=6b654ea1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b654ea1"]])

export default __exports__